import React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import { CoApplicantForm, AddressForm } from '../../forms/application-information-forms';
import * as styles from './application.less';
import { Applicant } from './applicant';
import { Address } from './address';
import { CitizenshipInformation } from './citizenship-information';

interface IPrimaryApplicantProps {
    coApplicant: CoApplicantForm;
    hasCoApplicant: FieldState<boolean>;
    primaryAddress: AddressForm;
    states: string[];
    validate: (fieldState?: FieldState<string>) => () => Promise<void>;
}

export const CoApplicant: React.FC<IPrimaryApplicantProps> = observer(
    ({ coApplicant, hasCoApplicant, primaryAddress, validate, states }) => {
        const {
            $: {
                PersonalInfo: personalInfo,
                Document: document,
                HomeAddress: homeAddress,
                SameAsPrimaryAddress: sameAsPrimaryAddress,
            },
        } = coApplicant;
        return (
            <React.Fragment>
                {hasCoApplicant.value && (
                    <React.Fragment>
                        <Applicant
                            personalInfo={personalInfo}
                            document={document}
                            states={states}
                            validate={validate}
                        />
                        <div className={styles.row}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={styles.radio}
                                        checked={sameAsPrimaryAddress.value}
                                        onChange={async (e) => {
                                            sameAsPrimaryAddress.onChange(e.target.checked);
                                            await validate()();
                                        }}
                                    />
                                }
                                label="Address is the same as applicant"
                            />
                        </div>
                        <Address
                            address={
                                sameAsPrimaryAddress.value
                                    ? primaryAddress
                                    : coApplicant.$.HomeAddress
                            }
                            states={states}
                            disabled={sameAsPrimaryAddress.value}
                            validate={validate}
                        />
                        <CitizenshipInformation personalInfo={coApplicant.$.PersonalInfo} />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
);
